import angular from 'angular';
import { MeurhBureausIndexController } from './index/bureaus.index.controller';
import { MeurhBureausListRouting } from './bureaus.routes';
import { MeurhBureausModalController } from './modal/bureaus.modal.controller';
import { MeurhBureausModalService } from './modal/bureaus.modal.service';
import { MeurhBureausService } from './bureaus.service';
import { MeurhBureausEquipesAdministradoresComponent } from './equipes/administradores/bureaus-equipes-administradores.component';
import { MeurhBureausEquipesMembrosComponent } from './equipes/membros/bureaus-equipes-membros.component';
import { MeurhBureausEquipesModalController } from './equipes/modal/bureaus-equipes.modal.controller';
import { MeurhBureausEquipesModalService } from './equipes/modal/bureaus-equipes.modal.service';
import { MeurhBureausEquipesService } from './bureaus-equipes.service';

export const MeurhBureausModule = angular.module('MeurhBureausModule', ['ui.router.state', ])
    .controller('MeurhBureausIndexController', MeurhBureausIndexController)
    .controller('MeurhBureausModalController', MeurhBureausModalController)
    .controller('MeurhBureausEquipesModalController', MeurhBureausEquipesModalController)
    .service('MeurhBureausModalService', MeurhBureausModalService)
    .service('MeurhBureausService', MeurhBureausService)
    .service('MeurhBureausEquipesModalService', MeurhBureausEquipesModalService)
    .service('MeurhBureausEquipesService', MeurhBureausEquipesService)
    .component(MeurhBureausEquipesAdministradoresComponent.selector, MeurhBureausEquipesAdministradoresComponent)
    .component(MeurhBureausEquipesMembrosComponent.selector, MeurhBureausEquipesMembrosComponent)
    .config(MeurhBureausListRouting)
    .name;
